// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Game Management - Enterprise Corporate Design
   Matching ManageCompany Theme
   ============================================ */

/* CSS Variables - Matching ManageCompany Theme */
:root {
  --game-management-bg: #f8f9fa;
  --game-management-text: #000000;
  --game-management-text-muted: #4a5568;
  --game-management-border: rgba(135, 206, 235, 0.3);
  --light-sky-blue: #87ceeb;
  --light-red: #ff6b6b;
  --white: #ffffff;
  --navy-blue: #001f3f;
  --transition: all 0.2s ease;
}

/* ============================================
   Main Container
   ============================================ */
.GameManagement_gameManagement__Shxts {
  min-height: calc(100vh - 60px);
  background: var(--game-management-bg);
  padding: 1.5rem;
  color: var(--game-management-text);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* ============================================
   Header
   ============================================ */
.GameManagement_header__FKWm5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.GameManagement_headerLeft__xGi8m {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.GameManagement_headerIcon__Tzw6B {
  color: var(--light-sky-blue);
}

.GameManagement_title__emUfS {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--game-management-text);
  margin: 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.GameManagement_addButton__AFtD4 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: #000000;
  color: var(--white);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.GameManagement_addButton__AFtD4:hover {
  background: #001f3f;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.GameManagement_addButton__AFtD4:active {
  transform: translateY(0);
}

/* ============================================
   Notification
   ============================================ */
.GameManagement_notification__inzzp {
  padding: 0.875rem 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
  animation: GameManagement_slideDown__dBSEN 0.3s ease;
}

.GameManagement_notificationSuccess__VfKeg,
.GameManagement_notificationsuccess__uej1h {
  background: rgba(67, 160, 71, 0.1);
  color: #43a047;
  border: 1px solid rgba(67, 160, 71, 0.3);
}

.GameManagement_notificationError__b3gE2,
.GameManagement_notificationerror__UKIhy {
  background: rgba(255, 107, 107, 0.1);
  color: var(--light-red);
  border: 1px solid rgba(255, 107, 107, 0.3);
}

@keyframes GameManagement_slideDown__dBSEN {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============================================
   Loading & Error States
   ============================================ */
.GameManagement_loadingContainer__h4-5j {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.GameManagement_spinner__tNtjI {
  color: var(--light-sky-blue);
  animation: GameManagement_spin__mhWV2 1s linear infinite;
}

@keyframes GameManagement_spin__mhWV2 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.GameManagement_errorAlert__GOxIs {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--light-red);
  color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.GameManagement_errorAlert__GOxIs svg {
  flex-shrink: 0;
}

/* ============================================
   Table Container
   ============================================ */
.GameManagement_tableContainer__XEzqV {
  background: var(--white);
  border: 1px solid var(--game-management-border);
  border-radius: 0.5rem;
  overflow-x: auto;
  overflow-y: visible;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.GameManagement_table__Ectyl {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}

.GameManagement_table__Ectyl thead {
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
}

.GameManagement_table__Ectyl th {
  padding: 1rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
  white-space: nowrap;
}

.GameManagement_table__Ectyl tbody tr {
  border-bottom: 1px solid var(--game-management-border);
  transition: var(--transition);
}

.GameManagement_table__Ectyl tbody tr:hover {
  background: rgba(135, 206, 235, 0.05);
}

.GameManagement_table__Ectyl tbody tr:last-child {
  border-bottom: none;
}

.GameManagement_table__Ectyl td {
  padding: 1rem;
  font-size: 0.875rem;
  color: var(--game-management-text);
  white-space: nowrap;
}

.GameManagement_emptyState__KQNHB {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--game-management-text-muted);
  font-style: italic;
}

/* ============================================
   Status Badge
   ============================================ */
.GameManagement_statusBadge__mHWGN {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.GameManagement_statusActive__BAHeX {
  background: rgba(67, 160, 71, 0.1);
  color: #43a047;
}

.GameManagement_statusInactive__efPzJ {
  background: rgba(255, 107, 107, 0.1);
  color: var(--light-red);
}

/* ============================================
   Action Buttons
   ============================================ */
.GameManagement_actionButtons__a86\\+B {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.GameManagement_iconButton__O9qC\\+ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--game-management-border);
  border-radius: 0.375rem;
  color: var(--game-management-text);
  cursor: pointer;
  transition: var(--transition);
}

.GameManagement_iconButton__O9qC\\+:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
  color: var(--light-sky-blue);
}

.GameManagement_iconButton__O9qC\\+:active {
  transform: scale(0.95);
}

.GameManagement_deleteButton__t95F8:hover {
  background: rgba(255, 107, 107, 0.1);
  border-color: var(--light-red);
  color: var(--light-red);
}

.GameManagement_resultButton__7OVvk {
  color: #d69e2e;
  border-color: rgba(214, 158, 46, 0.5);
}

.GameManagement_resultButton__7OVvk:hover {
  background: rgba(214, 158, 46, 0.12);
  border-color: #d69e2e;
  color: #b7791f;
}

/* ============================================
   Modal - Wide and Scrollable
   ============================================ */
.GameManagement_modalOverlay__TWlqf {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.GameManagement_modal__fAn6h {
  background: var(--white);
  border-radius: 0.5rem;
  width: 100%;
  max-width: 1200px;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

/* Lets the body shrink inside the capped modal so only it scrolls. */
.GameManagement_modalForm__GsFeI {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.GameManagement_modalHeader__vpKTK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  color: var(--white);
  border-radius: 0.5rem 0.5rem 0 0;
  flex-shrink: 0;
}

.GameManagement_modalTitle__f-QUE {
  font-size: 1.125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0;
}

.GameManagement_closeButton__uNlCt {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  color: var(--white);
  cursor: pointer;
  border-radius: 0.25rem;
  transition: var(--transition);
}

.GameManagement_closeButton__uNlCt:hover {
  background: rgba(255, 255, 255, 0.1);
}

.GameManagement_modalBody__9Olst {
  padding: 1.5rem;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
}

.GameManagement_modalFooter__wtfft {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid var(--game-management-border);
  background: #f8f9fa;
  border-radius: 0 0 0.5rem 0.5rem;
  flex-shrink: 0;
}

/* ============================================
   Form Elements
   ============================================ */
.GameManagement_formRow__pCdCl {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.GameManagement_formRowThree__N1vmG {
  grid-template-columns: repeat(3, 1fr);
}

.GameManagement_formGroup__5f5xH {
  display: flex;
  flex-direction: column;
}

.GameManagement_unitInput__Dcoep {
  position: relative;
  display: flex;
  align-items: center;
}

.GameManagement_unitInput__Dcoep .GameManagement_input__DrfUR {
  padding-right: 3rem;
}

.GameManagement_unitSuffix__oXRUN {
  position: absolute;
  right: 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--game-management-text-muted);
  text-transform: uppercase;
  pointer-events: none;
}

.GameManagement_label__NEUrD {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--game-management-text);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.GameManagement_required__Yu2TG {
  color: var(--light-red);
}

.GameManagement_input__DrfUR {
  width: 100%;
  padding: 0.625rem 0.875rem;
  font-size: 0.875rem;
  border: 1px solid var(--game-management-border);
  border-radius: 0.375rem;
  background: var(--white);
  color: var(--game-management-text);
  transition: var(--transition);
  box-sizing: border-box;
}

.GameManagement_input__DrfUR:focus {
  outline: none;
  border-color: var(--light-sky-blue);
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

.GameManagement_input__DrfUR::placeholder {
  color: var(--game-management-text-muted);
}

.GameManagement_switchLabel__aEAMW {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.5rem 0;
}

.GameManagement_switch__kFEcT {
  width: 40px;
  height: 20px;
  appearance: none;
  background: #cbd5e0;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: var(--transition);
  flex-shrink: 0;
}

.GameManagement_switch__kFEcT:checked {
  background: var(--light-sky-blue);
}

.GameManagement_switch__kFEcT::before {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--white);
  top: 2px;
  left: 2px;
  transition: var(--transition);
}

.GameManagement_switch__kFEcT:checked::before {
  left: 22px;
}

.GameManagement_switchText__Sureq {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--game-management-text);
}

.GameManagement_submitButton__K2nP5 {
  padding: 0.625rem 1.5rem;
  background: var(--light-sky-blue);
  color: var(--white);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.GameManagement_submitButton__K2nP5:hover {
  background: #6bb6d4;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);
}

.GameManagement_submitButton__K2nP5:active {
  transform: translateY(0);
}

.GameManagement_cancelButton__n\\+fqQ {
  padding: 0.625rem 1.5rem;
  background: transparent;
  color: var(--game-management-text);
  border: 1px solid var(--game-management-border);
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.GameManagement_cancelButton__n\\+fqQ:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
}

/* ============================================
   Manual Draw Times
   ============================================ */
.GameManagement_manualTimes__2u9w4 {
  margin-bottom: 1.25rem;
  padding: 1rem;
  border: 1px solid var(--game-management-border);
  border-radius: 0.5rem;
  background: rgba(135, 206, 235, 0.06);
}

.GameManagement_manualTimesHeader__S1u0P {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.GameManagement_manualTimesHeader__S1u0P .GameManagement_label__NEUrD {
  margin-bottom: 0;
}

.GameManagement_manualTimesHint__RZWos {
  margin: 0 0 0.75rem;
  font-size: 0.8rem;
  color: var(--game-management-text-muted);
}

.GameManagement_manualTimeRow__J-Fpx {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.GameManagement_manualTimeIndex__Ff9fT {
  min-width: 1.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--game-management-text-muted);
}

.GameManagement_manualTimeSelect__duawl {
  width: auto;
  min-width: 4.75rem;
}

.GameManagement_manualTimeColon__3NOYP {
  font-weight: 700;
}

.GameManagement_manualTimesEmpty__naMb1 {
  font-size: 0.85rem;
  color: var(--light-red);
  margin: 0 0 0.5rem;
}

.GameManagement_addTimeButton__yP69Q {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.8rem;
  background: var(--white);
  color: var(--navy-blue);
  border: 1px solid var(--light-sky-blue);
  border-radius: 0.375rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.GameManagement_addTimeButton__yP69Q:hover {
  background: rgba(135, 206, 235, 0.15);
}

.GameManagement_manualTimeDuplicate__y9E3v .GameManagement_manualTimeSelect__duawl {
  border-color: var(--light-red);
  background: #fff5f5;
}

.GameManagement_manualTimeDuplicateText__VqRO7 {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--light-red);
}

.GameManagement_manualActions__PvR4d {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 0.75rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px dashed var(--game-management-border);
}

.GameManagement_manualActionCard__47lAp {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.875rem 1rem;
  background: var(--white);
  border: 1px solid var(--game-management-border);
  border-radius: 0.75rem;
  transition: var(--transition);
}

label.GameManagement_manualActionCard__47lAp {
  cursor: pointer;
}

label.GameManagement_manualActionCard__47lAp:hover {
  border-color: var(--light-sky-blue);
  box-shadow: 0 2px 10px rgba(135, 206, 235, 0.2);
}

.GameManagement_manualActionCardOn__cExUU {
  border-color: var(--light-sky-blue);
  background: linear-gradient(135deg, rgba(135, 206, 235, 0.14) 0%, rgba(255, 255, 255, 1) 70%);
}

.GameManagement_manualActionBody__9RGBj {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
  min-width: 0;
}

.GameManagement_manualActionTitle__TIhWq {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--navy-blue);
}

.GameManagement_manualActionHint__O-bES {
  font-size: 0.75rem;
  line-height: 1.35;
  color: var(--game-management-text-muted);
}

.GameManagement_giveResultButton__IwvT7 {
  flex-shrink: 0;
  padding: 0.55rem 1rem;
  background: linear-gradient(135deg, #001f3f 0%, #003366 100%);
  color: var(--white);
  border: none;
  border-radius: 0.5rem;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  transition: var(--transition);
}

.GameManagement_giveResultButton__IwvT7:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 31, 63, 0.3);
}

.GameManagement_giveResultButton__IwvT7:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ============================================
   Responsive Design - Tablet
   ============================================ */
@media (max-width: 1024px) {
  .GameManagement_gameManagement__Shxts {
    padding: 1.25rem;
  }

  .GameManagement_title__emUfS {
    font-size: 1.25rem;
  }

  .GameManagement_table__Ectyl th,
  .GameManagement_table__Ectyl td {
    padding: 0.875rem;
    font-size: 0.8125rem;
  }

  .GameManagement_modal__fAn6h {
    max-width: 95%;
  }

  .GameManagement_formRow__pCdCl {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

/* ============================================
   Responsive Design - Mobile
   ============================================ */
@media (max-width: 768px) {
  .GameManagement_gameManagement__Shxts {
    padding: 1rem;
  }

  .GameManagement_header__FKWm5 {
    flex-direction: column;
    align-items: flex-start;
  }

  .GameManagement_title__emUfS {
    font-size: 1.125rem;
  }

  .GameManagement_addButton__AFtD4 {
    width: 100%;
    justify-content: center;
  }

  .GameManagement_tableContainer__XEzqV {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .GameManagement_table__Ectyl {
    min-width: 1000px;
  }

  .GameManagement_table__Ectyl th,
  .GameManagement_table__Ectyl td {
    padding: 0.75rem 0.5rem;
    font-size: 0.75rem;
  }

  .GameManagement_modal__fAn6h {
    max-width: 100%;
    max-height: calc(100vh - 3rem);
    max-height: calc(100dvh - 3rem);
    margin: 0.5rem;
  }

  .GameManagement_modalHeader__vpKTK {
    padding: 1rem;
  }

  .GameManagement_modalTitle__f-QUE {
    font-size: 1rem;
  }

  .GameManagement_modalBody__9Olst {
    padding: 1rem;
  }

  .GameManagement_modalFooter__wtfft {
    padding: 1rem;
    flex-direction: column;
  }

  .GameManagement_submitButton__K2nP5,
  .GameManagement_cancelButton__n\\+fqQ {
    width: 100%;
  }

  .GameManagement_formRow__pCdCl {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
  }
}

/* ============================================
   Responsive Design - Small Mobile
   ============================================ */
@media (max-width: 480px) {
  .GameManagement_gameManagement__Shxts {
    padding: 0.75rem;
  }

  .GameManagement_title__emUfS {
    font-size: 1rem;
  }

  .GameManagement_table__Ectyl {
    min-width: 800px;
  }

  .GameManagement_table__Ectyl th,
  .GameManagement_table__Ectyl td {
    padding: 0.625rem 0.375rem;
    font-size: 0.6875rem;
  }

  .GameManagement_iconButton__O9qC\\+ {
    width: 28px;
    height: 28px;
  }

  .GameManagement_iconButton__O9qC\\+ svg {
    width: 16px;
    height: 16px;
  }

  .GameManagement_modalHeader__vpKTK {
    padding: 0.875rem;
  }

  .GameManagement_modalBody__9Olst {
    padding: 0.875rem;
  }

  .GameManagement_modalFooter__wtfft {
    padding: 0.875rem;
  }
}

/* ============================================
   Accessibility
   ============================================ */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

/* Focus states for keyboard navigation */
.GameManagement_iconButton__O9qC\\+:focus-visible,
.GameManagement_addButton__AFtD4:focus-visible,
.GameManagement_submitButton__K2nP5:focus-visible,
.GameManagement_cancelButton__n\\+fqQ:focus-visible,
.GameManagement_closeButton__uNlCt:focus-visible,
.GameManagement_input__DrfUR:focus-visible,
.GameManagement_switch__kFEcT:focus-visible {
  outline: 2px solid var(--light-sky-blue);
  outline-offset: 2px;
}

/* Custom scrollbar for modal */
.GameManagement_modalBody__9Olst::-webkit-scrollbar {
  width: 8px;
}

.GameManagement_modalBody__9Olst::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.GameManagement_modalBody__9Olst::-webkit-scrollbar-thumb {
  background: var(--light-sky-blue);
  border-radius: 4px;
}

.GameManagement_modalBody__9Olst::-webkit-scrollbar-thumb:hover {
  background: #6bb6d4;
}

`, "",{"version":3,"sources":["webpack://./src/styles/GameManagement.module.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,iDAAiD;AACjD;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,qCAAqC;EACrC,kDAAkD;EAClD,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;iDAEiD;AACjD;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,eAAe;EACf,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;iDAEiD;AACjD;EACE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,oDAA8B;AAChC;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,wDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;EACtD,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,+CAA+C;EAC/C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,qEAAqE;AACrE;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0EAA0E;EAC1E,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,mDAAmD;EACnD,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,+CAA+C;EAC/C,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,kCAAkC;EAClC,+CAA+C;EAC/C,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;;iDAEiD;AACjD;EACE,sBAAsB;EACtB,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,uCAAuC;EACvC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,+CAA+C;EAC/C,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;EACnC,6FAA6F;AAC/F;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,+BAA+B;IAC/B,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,sCAAsC;IACtC,qCAAqC;EACvC;AACF;;AAEA,yCAAyC;AACzC;;;;;;;EAOE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ============================================\n   Game Management - Enterprise Corporate Design\n   Matching ManageCompany Theme\n   ============================================ */\n\n/* CSS Variables - Matching ManageCompany Theme */\n:root {\n  --game-management-bg: #f8f9fa;\n  --game-management-text: #000000;\n  --game-management-text-muted: #4a5568;\n  --game-management-border: rgba(135, 206, 235, 0.3);\n  --light-sky-blue: #87ceeb;\n  --light-red: #ff6b6b;\n  --white: #ffffff;\n  --navy-blue: #001f3f;\n  --transition: all 0.2s ease;\n}\n\n/* ============================================\n   Main Container\n   ============================================ */\n.gameManagement {\n  min-height: calc(100vh - 60px);\n  background: var(--game-management-bg);\n  padding: 1.5rem;\n  color: var(--game-management-text);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* ============================================\n   Header\n   ============================================ */\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.headerIcon {\n  color: var(--light-sky-blue);\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--game-management-text);\n  margin: 0;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.25rem;\n  background: #000000;\n  color: var(--white);\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.addButton:hover {\n  background: #001f3f;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.addButton:active {\n  transform: translateY(0);\n}\n\n/* ============================================\n   Notification\n   ============================================ */\n.notification {\n  padding: 0.875rem 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  animation: slideDown 0.3s ease;\n}\n\n.notificationSuccess,\n.notificationsuccess {\n  background: rgba(67, 160, 71, 0.1);\n  color: #43a047;\n  border: 1px solid rgba(67, 160, 71, 0.3);\n}\n\n.notificationError,\n.notificationerror {\n  background: rgba(255, 107, 107, 0.1);\n  color: var(--light-red);\n  border: 1px solid rgba(255, 107, 107, 0.3);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ============================================\n   Loading & Error States\n   ============================================ */\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.spinner {\n  color: var(--light-sky-blue);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.errorAlert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--light-red);\n  color: white;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.errorAlert svg {\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Table Container\n   ============================================ */\n.tableContainer {\n  background: var(--white);\n  border: 1px solid var(--game-management-border);\n  border-radius: 0.5rem;\n  overflow-x: auto;\n  overflow-y: visible;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1200px;\n}\n\n.table thead {\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n}\n\n.table th {\n  padding: 1rem;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n  white-space: nowrap;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid var(--game-management-border);\n  transition: var(--transition);\n}\n\n.table tbody tr:hover {\n  background: rgba(135, 206, 235, 0.05);\n}\n\n.table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.table td {\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: var(--game-management-text);\n  white-space: nowrap;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: var(--game-management-text-muted);\n  font-style: italic;\n}\n\n/* ============================================\n   Status Badge\n   ============================================ */\n.statusBadge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.statusActive {\n  background: rgba(67, 160, 71, 0.1);\n  color: #43a047;\n}\n\n.statusInactive {\n  background: rgba(255, 107, 107, 0.1);\n  color: var(--light-red);\n}\n\n/* ============================================\n   Action Buttons\n   ============================================ */\n.actionButtons {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.iconButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: 1px solid var(--game-management-border);\n  border-radius: 0.375rem;\n  color: var(--game-management-text);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.iconButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n  color: var(--light-sky-blue);\n}\n\n.iconButton:active {\n  transform: scale(0.95);\n}\n\n.deleteButton:hover {\n  background: rgba(255, 107, 107, 0.1);\n  border-color: var(--light-red);\n  color: var(--light-red);\n}\n\n.resultButton {\n  color: #d69e2e;\n  border-color: rgba(214, 158, 46, 0.5);\n}\n\n.resultButton:hover {\n  background: rgba(214, 158, 46, 0.12);\n  border-color: #d69e2e;\n  color: #b7791f;\n}\n\n/* ============================================\n   Modal - Wide and Scrollable\n   ============================================ */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.modal {\n  background: var(--white);\n  border-radius: 0.5rem;\n  width: 100%;\n  max-width: 1200px;\n  max-height: calc(100vh - 2rem);\n  max-height: calc(100dvh - 2rem);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n/* Lets the body shrink inside the capped modal so only it scrolls. */\n.modalForm {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  color: var(--white);\n  border-radius: 0.5rem 0.5rem 0 0;\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-size: 1.125rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin: 0;\n}\n\n.closeButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: var(--white);\n  cursor: pointer;\n  border-radius: 0.25rem;\n  transition: var(--transition);\n}\n\n.closeButton:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.modalBody {\n  padding: 1.5rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n}\n\n.modalFooter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.25rem 1.5rem;\n  border-top: 1px solid var(--game-management-border);\n  background: #f8f9fa;\n  border-radius: 0 0 0.5rem 0.5rem;\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Form Elements\n   ============================================ */\n.formRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.formRowThree {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n.unitInput {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.unitInput .input {\n  padding-right: 3rem;\n}\n\n.unitSuffix {\n  position: absolute;\n  right: 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--game-management-text-muted);\n  text-transform: uppercase;\n  pointer-events: none;\n}\n\n.label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--game-management-text);\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.required {\n  color: var(--light-red);\n}\n\n.input {\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--game-management-border);\n  border-radius: 0.375rem;\n  background: var(--white);\n  color: var(--game-management-text);\n  transition: var(--transition);\n  box-sizing: border-box;\n}\n\n.input:focus {\n  outline: none;\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n.input::placeholder {\n  color: var(--game-management-text-muted);\n}\n\n.switchLabel {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 0.5rem 0;\n}\n\n.switch {\n  width: 40px;\n  height: 20px;\n  appearance: none;\n  background: #cbd5e0;\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n  transition: var(--transition);\n  flex-shrink: 0;\n}\n\n.switch:checked {\n  background: var(--light-sky-blue);\n}\n\n.switch::before {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--white);\n  top: 2px;\n  left: 2px;\n  transition: var(--transition);\n}\n\n.switch:checked::before {\n  left: 22px;\n}\n\n.switchText {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--game-management-text);\n}\n\n.submitButton {\n  padding: 0.625rem 1.5rem;\n  background: var(--light-sky-blue);\n  color: var(--white);\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.submitButton:hover {\n  background: #6bb6d4;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);\n}\n\n.submitButton:active {\n  transform: translateY(0);\n}\n\n.cancelButton {\n  padding: 0.625rem 1.5rem;\n  background: transparent;\n  color: var(--game-management-text);\n  border: 1px solid var(--game-management-border);\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.cancelButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n}\n\n/* ============================================\n   Manual Draw Times\n   ============================================ */\n.manualTimes {\n  margin-bottom: 1.25rem;\n  padding: 1rem;\n  border: 1px solid var(--game-management-border);\n  border-radius: 0.5rem;\n  background: rgba(135, 206, 235, 0.06);\n}\n\n.manualTimesHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.manualTimesHeader .label {\n  margin-bottom: 0;\n}\n\n.manualTimesHint {\n  margin: 0 0 0.75rem;\n  font-size: 0.8rem;\n  color: var(--game-management-text-muted);\n}\n\n.manualTimeRow {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.manualTimeIndex {\n  min-width: 1.75rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--game-management-text-muted);\n}\n\n.manualTimeSelect {\n  width: auto;\n  min-width: 4.75rem;\n}\n\n.manualTimeColon {\n  font-weight: 700;\n}\n\n.manualTimesEmpty {\n  font-size: 0.85rem;\n  color: var(--light-red);\n  margin: 0 0 0.5rem;\n}\n\n.addTimeButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.8rem;\n  background: var(--white);\n  color: var(--navy-blue);\n  border: 1px solid var(--light-sky-blue);\n  border-radius: 0.375rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.addTimeButton:hover {\n  background: rgba(135, 206, 235, 0.15);\n}\n\n.manualTimeDuplicate .manualTimeSelect {\n  border-color: var(--light-red);\n  background: #fff5f5;\n}\n\n.manualTimeDuplicateText {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--light-red);\n}\n\n.manualActions {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 0.75rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px dashed var(--game-management-border);\n}\n\n.manualActionCard {\n  display: flex;\n  align-items: center;\n  gap: 0.875rem;\n  padding: 0.875rem 1rem;\n  background: var(--white);\n  border: 1px solid var(--game-management-border);\n  border-radius: 0.75rem;\n  transition: var(--transition);\n}\n\nlabel.manualActionCard {\n  cursor: pointer;\n}\n\nlabel.manualActionCard:hover {\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 2px 10px rgba(135, 206, 235, 0.2);\n}\n\n.manualActionCardOn {\n  border-color: var(--light-sky-blue);\n  background: linear-gradient(135deg, rgba(135, 206, 235, 0.14) 0%, rgba(255, 255, 255, 1) 70%);\n}\n\n.manualActionBody {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.manualActionTitle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--navy-blue);\n}\n\n.manualActionHint {\n  font-size: 0.75rem;\n  line-height: 1.35;\n  color: var(--game-management-text-muted);\n}\n\n.giveResultButton {\n  flex-shrink: 0;\n  padding: 0.55rem 1rem;\n  background: linear-gradient(135deg, #001f3f 0%, #003366 100%);\n  color: var(--white);\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.giveResultButton:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 31, 63, 0.3);\n}\n\n.giveResultButton:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   Responsive Design - Tablet\n   ============================================ */\n@media (max-width: 1024px) {\n  .gameManagement {\n    padding: 1.25rem;\n  }\n\n  .title {\n    font-size: 1.25rem;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.875rem;\n    font-size: 0.8125rem;\n  }\n\n  .modal {\n    max-width: 95%;\n  }\n\n  .formRow {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n/* ============================================\n   Responsive Design - Mobile\n   ============================================ */\n@media (max-width: 768px) {\n  .gameManagement {\n    padding: 1rem;\n  }\n\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .title {\n    font-size: 1.125rem;\n  }\n\n  .addButton {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .tableContainer {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table {\n    min-width: 1000px;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.75rem;\n  }\n\n  .modal {\n    max-width: 100%;\n    max-height: calc(100vh - 3rem);\n    max-height: calc(100dvh - 3rem);\n    margin: 0.5rem;\n  }\n\n  .modalHeader {\n    padding: 1rem;\n  }\n\n  .modalTitle {\n    font-size: 1rem;\n  }\n\n  .modalBody {\n    padding: 1rem;\n  }\n\n  .modalFooter {\n    padding: 1rem;\n    flex-direction: column;\n  }\n\n  .submitButton,\n  .cancelButton {\n    width: 100%;\n  }\n\n  .formRow {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    margin-bottom: 1rem;\n  }\n}\n\n/* ============================================\n   Responsive Design - Small Mobile\n   ============================================ */\n@media (max-width: 480px) {\n  .gameManagement {\n    padding: 0.75rem;\n  }\n\n  .title {\n    font-size: 1rem;\n  }\n\n  .table {\n    min-width: 800px;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.625rem 0.375rem;\n    font-size: 0.6875rem;\n  }\n\n  .iconButton {\n    width: 28px;\n    height: 28px;\n  }\n\n  .iconButton svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  .modalHeader {\n    padding: 0.875rem;\n  }\n\n  .modalBody {\n    padding: 0.875rem;\n  }\n\n  .modalFooter {\n    padding: 0.875rem;\n  }\n}\n\n/* ============================================\n   Accessibility\n   ============================================ */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n\n/* Focus states for keyboard navigation */\n.iconButton:focus-visible,\n.addButton:focus-visible,\n.submitButton:focus-visible,\n.cancelButton:focus-visible,\n.closeButton:focus-visible,\n.input:focus-visible,\n.switch:focus-visible {\n  outline: 2px solid var(--light-sky-blue);\n  outline-offset: 2px;\n}\n\n/* Custom scrollbar for modal */\n.modalBody::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modalBody::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.modalBody::-webkit-scrollbar-thumb {\n  background: var(--light-sky-blue);\n  border-radius: 4px;\n}\n\n.modalBody::-webkit-scrollbar-thumb:hover {\n  background: #6bb6d4;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameManagement": `GameManagement_gameManagement__Shxts`,
	"header": `GameManagement_header__FKWm5`,
	"headerLeft": `GameManagement_headerLeft__xGi8m`,
	"headerIcon": `GameManagement_headerIcon__Tzw6B`,
	"title": `GameManagement_title__emUfS`,
	"addButton": `GameManagement_addButton__AFtD4`,
	"notification": `GameManagement_notification__inzzp`,
	"slideDown": `GameManagement_slideDown__dBSEN`,
	"notificationSuccess": `GameManagement_notificationSuccess__VfKeg`,
	"notificationsuccess": `GameManagement_notificationsuccess__uej1h`,
	"notificationError": `GameManagement_notificationError__b3gE2`,
	"notificationerror": `GameManagement_notificationerror__UKIhy`,
	"loadingContainer": `GameManagement_loadingContainer__h4-5j`,
	"spinner": `GameManagement_spinner__tNtjI`,
	"spin": `GameManagement_spin__mhWV2`,
	"errorAlert": `GameManagement_errorAlert__GOxIs`,
	"tableContainer": `GameManagement_tableContainer__XEzqV`,
	"table": `GameManagement_table__Ectyl`,
	"emptyState": `GameManagement_emptyState__KQNHB`,
	"statusBadge": `GameManagement_statusBadge__mHWGN`,
	"statusActive": `GameManagement_statusActive__BAHeX`,
	"statusInactive": `GameManagement_statusInactive__efPzJ`,
	"actionButtons": `GameManagement_actionButtons__a86+B`,
	"iconButton": `GameManagement_iconButton__O9qC+`,
	"deleteButton": `GameManagement_deleteButton__t95F8`,
	"resultButton": `GameManagement_resultButton__7OVvk`,
	"modalOverlay": `GameManagement_modalOverlay__TWlqf`,
	"modal": `GameManagement_modal__fAn6h`,
	"modalForm": `GameManagement_modalForm__GsFeI`,
	"modalHeader": `GameManagement_modalHeader__vpKTK`,
	"modalTitle": `GameManagement_modalTitle__f-QUE`,
	"closeButton": `GameManagement_closeButton__uNlCt`,
	"modalBody": `GameManagement_modalBody__9Olst`,
	"modalFooter": `GameManagement_modalFooter__wtfft`,
	"formRow": `GameManagement_formRow__pCdCl`,
	"formRowThree": `GameManagement_formRowThree__N1vmG`,
	"formGroup": `GameManagement_formGroup__5f5xH`,
	"unitInput": `GameManagement_unitInput__Dcoep`,
	"input": `GameManagement_input__DrfUR`,
	"unitSuffix": `GameManagement_unitSuffix__oXRUN`,
	"label": `GameManagement_label__NEUrD`,
	"required": `GameManagement_required__Yu2TG`,
	"switchLabel": `GameManagement_switchLabel__aEAMW`,
	"switch": `GameManagement_switch__kFEcT`,
	"switchText": `GameManagement_switchText__Sureq`,
	"submitButton": `GameManagement_submitButton__K2nP5`,
	"cancelButton": `GameManagement_cancelButton__n+fqQ`,
	"manualTimes": `GameManagement_manualTimes__2u9w4`,
	"manualTimesHeader": `GameManagement_manualTimesHeader__S1u0P`,
	"manualTimesHint": `GameManagement_manualTimesHint__RZWos`,
	"manualTimeRow": `GameManagement_manualTimeRow__J-Fpx`,
	"manualTimeIndex": `GameManagement_manualTimeIndex__Ff9fT`,
	"manualTimeSelect": `GameManagement_manualTimeSelect__duawl`,
	"manualTimeColon": `GameManagement_manualTimeColon__3NOYP`,
	"manualTimesEmpty": `GameManagement_manualTimesEmpty__naMb1`,
	"addTimeButton": `GameManagement_addTimeButton__yP69Q`,
	"manualTimeDuplicate": `GameManagement_manualTimeDuplicate__y9E3v`,
	"manualTimeDuplicateText": `GameManagement_manualTimeDuplicateText__VqRO7`,
	"manualActions": `GameManagement_manualActions__PvR4d`,
	"manualActionCard": `GameManagement_manualActionCard__47lAp`,
	"manualActionCardOn": `GameManagement_manualActionCardOn__cExUU`,
	"manualActionBody": `GameManagement_manualActionBody__9RGBj`,
	"manualActionTitle": `GameManagement_manualActionTitle__TIhWq`,
	"manualActionHint": `GameManagement_manualActionHint__O-bES`,
	"giveResultButton": `GameManagement_giveResultButton__IwvT7`
};
export default ___CSS_LOADER_EXPORT___;
